<style scoped>@import "../css/moniter.css";</style>
<template>
    <div style="width: 100%; height: 100%; overflow: hidden;">
        <div class="header">
			<div class="header_cer">
				<div class="hl"></div>
				<div class="logo"></div>
				<div class="hr"></div>
			</div>
			<div class="header_right">
				<a href="#"><em class="em1"></em>{{nickName}}</a>
			</div>
			<div class="header_bottom"></div>
		</div>
		<div class="main">
			<div class="main_left">
				<div class="main_left_box">
					<div class="main_left_title">
						<div class="title">上月单元工程完成情况</div>
						<div class="title_right" style="width:calc(100% - 245px);"></div>
					</div>
					<div class="tableTop">
						<table>
							<tr>
								<td><div class="ddd">工程</div></td>
								<td><div class="ddd">计划(m)</div></td>
								<td><div class="ddd">完成(m)</div></td>
								<td><div class="ddd">进度(%)</div></td>
							</tr>
						</table>
					</div>
					<div class="main_left_cer_box">
						<table>
							<tr v-for="item in dyList" :key="item.id">
								<td><div class="ddd">{{item.code}}</div></td>
								<td><div class="ddd">{{item.plan_length}}</div></td>
								<td><div class="ddd">{{item.complete_length}}</div></td>
								<td><div class="ddd">{{item.complete_length_percent}}</div></td>
							</tr>
						</table>
					</div>
				</div>
				<div class="main_left_box">
					<div class="main_left_title">
						<div class="title">单位工程完成情况</div>
						<div class="title_right" style="width:calc(100% - 200px);"></div>
					</div>
					<div class="tableTop">
						<table>
							<tr>
								<td style="width:120px"><div class="ddd" style="width:120px">工程</div></td>
								<td><div class="ddd">计划(m)</div></td>
								<td><div class="ddd">完成(m)</div></td>
								<td><div class="ddd">进度(%)</div></td>
							</tr>
						</table>
					</div>
					<div class="main_left_cer_box">
						<table>
							<tr v-for="item in dwList" :key="item.id">
								<td style="width:120px"><div class="ddd" style="width:120px">{{item.code}}</div></td>
								<td><div class="ddd">{{item.plan_length}}</div></td>
								<td><div class="ddd">{{item.complete_length}}</div></td>
								<td><div class="ddd">{{item.complete_length_percent}}</div></td>
							</tr>
						</table>
					</div>
				</div>
				<div class="main_left_box" id="Partprojectprogress">
					<div class="main_left_title">
						<div class="title">分部工程完成情况</div>
						<div class="title_right" style="width:calc(100% - 200px);"></div>
					</div>
					<div class="tableTop">
						<table>
							<tr>
								<td style="width:120px"><div class="ddd" style="width:120px">工程</div></td>
								<td><div class="ddd">计划(m)</div></td>
								<td><div class="ddd">完成(m)</div></td>
								<td><div class="ddd">进度(%)</div></td>
								<td><div class="ddd">注浆量(t)</div></td>
							</tr>
						</table>
					</div>
					<div class="main_left_cer_box">
						<table>
							<tr v-for="item in fbList" :key="item.id">
								<td style="width:120px"><div class="ddd" style="width:120px">{{item.code}}</div></td>
								<td><div class="ddd">{{item.plan_length}}</div></td>
								<td><div class="ddd">{{item.complete_length}}</div></td>
								<td><div class="ddd">{{item.complete_length_percent}}</div></td>
                                <td><div class="ddd">{{item.complete_volume}}</div></td>
							</tr>
						</table>
					</div>
				</div>
			</div>
			<div class="main_cer">
				<div class="main_cer_box1">
					<div class="main_left_title">
						<div class="title">GJ监测系统</div>
						<div class="title_right" style="width:calc(100% - 200px);"></div>
					</div>
					<div class="main_cer_cer_box">
						<dl>
							<dt>
								<div class="text">
									<p>{{project.complete_length_percent}}</p>
									<span>总体进度(%)</span>
								</div>
							</dt>
							<dd>
								<div class="text">
									<p v-if="project.complete_length<1000">{{project.complete_length}}</p>
                                    <p v-else-if="project.complete_length<10000" style="font-size: 28px">{{project.complete_length}}</p>
                                    <p v-else-if="project.complete_length<100000" style="font-size: 25px">{{project.complete_length}}</p>
                                    <p v-else-if="project.complete_length<1000000" style="font-size: 22px">{{project.complete_length}}</p>
                                    <p v-else-if="project.complete_length<10000000" style="font-size: 20px">{{project.complete_length}}</p>
									<span>完成长度(m)</span>
								</div>
							</dd>
                            <dd>
								<div class="text">
									<p v-if="project.complete_m2<1000">{{project.complete_m2}}</p>
                                    <p v-else-if="project.complete_m2<10000" style="font-size: 28px">{{project.complete_m2}}</p>
                                    <p v-else-if="project.complete_m2<100000" style="font-size: 25px">{{project.complete_m2}}</p>
                                    <p v-else-if="project.complete_m2<1000000" style="font-size: 22px">{{project.complete_m2}}</p>
                                    <p v-else-if="project.complete_m2<10000000" style="font-size: 20px">{{project.complete_m2}}</p>
									<span>完成平方(m²)</span>
								</div>
							</dd>
							<dd>
								<div class="text">
									<p v-if="project.complete_volume<1000">{{project.complete_volume}}</p>
                                    <p v-else-if="project.complete_volume<10000" style="font-size: 28px">{{project.complete_volume}}</p>
                                    <p v-else-if="project.complete_volume<100000" style="font-size: 25px">{{project.complete_volume}}</p>
                                    <p v-else-if="project.complete_volume<1000000" style="font-size: 22px">{{project.complete_volume}}</p>
                                    <p v-else-if="project.complete_volume<10000000" style="font-size: 20px">{{project.complete_volume}}</p>
									<span>总注浆量(m³)</span>
								</div>
							</dd>
							<dd>
								<div class="text">
									<p v-if="project.complete_ash<1000">{{project.complete_ash}}</p>
                                    <p v-else-if="project.complete_ash<10000" style="font-size: 28px">{{project.complete_ash}}</p>
                                    <p v-else-if="project.complete_ash<100000" style="font-size: 25px">{{project.complete_ash}}</p>
                                    <p v-else-if="project.complete_ash<1000000" style="font-size: 22px">{{project.complete_ash}}</p>
                                    <p v-else-if="project.complete_ash<10000000" style="font-size: 20px">{{project.complete_ash}}</p>
									<span>总注灰量(t)</span>
								</div>
							</dd>
						</dl>
						<div class="dlright" id="pie_echart"></div>
					</div>
				</div>
				<div class="main_cer_box2">
					<div class="main_left_title">
						<div class="title">GJ施工分布</div>
						<div class="title_right" style="width:calc(100% - 200px);"></div>
					</div>
					<div class="main_cer_cer_box" v-if="pid==35">
                        <iframe src="https://service.dy-gj.cn/yanshi/" width="100%" height="100%" border="0"></iframe>
                    </div>
                    <div class="main_cer_cer_box" v-else-if="pid==61">
                        <iframe src="https://service.dy-gj.cn/pingjiang/" width="100%" height="100%" border="0"></iframe>
                    </div>
                    <div class="main_cer_cer_box" v-else-if="pid==66">
                        <iframe src="https://service.dy-gj.cn/luoning/" width="100%" height="100%" border="0"></iframe>
                    </div>
                    <div class="main_cer_cer_box" v-else-if="pid==77">
                        <iframe src="https://service.dy-gj.cn/taian/" width="100%" height="100%" border="0"></iframe>
                    </div>
                    <div class="main_cer_cer_box" v-else-if="pid>0" :style="'background: url('+imgServer+'/moniter/bg_img/'+pid+'.png) no-repeat; background-size: 100% 100%;'"></div>
				</div>
			</div>
			<div class="main_right">
				<div class="main_right_box">
					<div class="main_right_title">
						<div class="title">接触式灌浆实时监测</div>
						<div class="title_right"></div>
					</div>
					<div class="main_right_nav">
						<div class="title_nav" v-if="contactList && contactList.length>0">
							<ul>
								<li @click="changeContact(idx)" v-for="(item,idx) in contactList" :key="'c'+item.id" :class="idx==contact_index?'on':''">{{item.code}}</li>
							</ul>
						</div>
						<!-- <span>设备位置：</span> -->
					</div>
					<div class="title_nav main_right_tongdao" v-if="contactList && contactList.length>0">
						<ul>
							<li @click="changeChannel(1)" :class="channel_index==1?'on':''">通道1</li>
							<li @click="changeChannel(2)" :class="channel_index==2?'on':''">通道2</li>
						</ul>
                        <div class="loca">
                            <span style="margin-right: 20px" v-if="contactList[contact_index].state==1">状态：在线</span>
                            <span style="margin-right: 20px" v-else>状态：离线</span>
                            <span>所在位置：{{contactList[contact_index].location}}</span>
                        </div>
					</div>
					<dl>
						<dt id="line1"></dt>
						<dd id="line2"></dd>
						<dd id="line3"></dd>
					</dl>
				</div>
				<div class="main_right_box">
					<div class="main_right_title">
						<div class="title">非接触式灌浆实时监测</div>
						<div class="title_right title_right1"></div>
					</div>
					<div class="main_right_nav">
						<div class="title_nav" id="ftitle_nav">
							<ul>
								<li @click="changeUnContact(idx)" v-for="(item,idx) in uncontactList" :key="'c'+item.id" :class="idx==uncontact_index?'on':''">{{item.code}}</li>
							</ul>
						</div>
						<!-- <span>设备位置：<label id="ftitle_nav_text">1</label>号灌浆站</span> -->
					</div>
                    <div class="title_nav main_right_tongdao" v-if="uncontactList && uncontactList.length>0">
                        <div class="loca" style="top: -8px">
                            <span style="margin-right: 20px" v-if="uncontactList[uncontact_index].state==1">状态：在线</span>
                            <span style="margin-right: 20px" v-else>状态：离线</span>
                            <span>所在位置：{{uncontactList[uncontact_index].location}}</span>
                        </div>
					</div>
					<dl class="gao">
						<dt id="line4"></dt>
						<dd id="line5"></dd>
						<dd id="line6"></dd>
					</dl>
				</div>
			</div>
		</div>
    </div>
</template>

<script>
import { indexData,realData } from "@/api/moniter";
import { continueSession} from '@/api/login'
import config from "@/config/index"
import { applyLineChartTheme } from '@/libs/lineChartTheme'

// 引入基本模板
let echarts = require('echarts/lib/echarts')
require('echarts/lib/chart/line')
require('echarts/lib/chart/pie')
require('echarts/lib/chart/scatter')
require('echarts/lib/component/tooltip')
require('echarts/lib/component/grid')
require('echarts/lib/component/legend')
require('echarts/lib/component/title')

export default {
    name: 'moniter',
    data() {
        return {
            user_id: 0,
            pid: 0,
            nickName: '',
            project: {},
            dyList: [],
            dwList: [],
            fbList: [],
            limitConnect: 0,
            contactList: [],
            uncontactList: [],
            contact_index: 0,
            channel_index: 1,
            uncontact_index: 0,
            contact_timmer: 1,
            channel_timmer: 1,
            uncontact_timmer: 1,
            line1_echart: null,
            line2_echart: null,
            line3_echart: null,
            line4_echart: null,
            line5_echart: null,
            line6_echart: null,
            pie_option: {
                tooltip: {
                    trigger: 'item'
                },
                legend: {
                    orient: 'horizontal',
                    x:'center',
                    y:'bottom',
                    textStyle: {
                        color: '#ffffff',
                        fontSize: '14px',
                    },
                },
                series: [{
                    type: 'pie',
                    radius: '68%',
                    center: ["50%", "42%"],
                    data: [
                        { name: '固结灌浆',value: 0},
                        { name: '帷幕灌浆',value: 0},
                        { name: '回填灌浆',value: 0},
                    ],
                    labelLine: {
                        length: 8,
                        lineStyle: {
                            width: 1, 
                            color: "#fff", 
                        }
                    },
                    label: {
                        color: '#fff'
                    },
                    itemStyle: {
                        color: function(params) {
                            var colorList = [
                            {
                                c1: ' #FF9891',  
                                c2: '#FF5F58'                                                                   
                            },
                            {
                                c1: '#35D6E7', 
                                c2: '#4066F8'
                            },
                            {
                                c1: '#68DCA3',
                                c2: '#37B76A'
                            }]
                                return new echarts.graphic.LinearGradient(1, 0, 0, 0, [{ 
                                offset: 0,
                                color: colorList[params.dataIndex].c1
                            }, {
                                offset: 1,
                                color: colorList[params.dataIndex].c2
                            }])   
                        },
                        label: {
                            show: true,
                            formatter: "{c}"
                        }
                    }
                }]
            },
            line1_option: {
                title: {
                    text: '流量(L)',
                    textStyle: {
                        color: '#fff',
                        fontSize:14,
                        fontWeight: 'normar'
                    },
                    x: 'center'
                },
                grid: { left: '20', right: '20',top:'40',bottom: '10', containLabel: true},
                xAxis: {
                    show:false,
                    type: 'category',
                    data: [],
                    boundaryGap: false,
                },
                yAxis: {
                    type: 'value',
                    splitLine: {
                        show: true,
                        lineStyle: {
                            color: '#404750', 
                            width: 1, 
                        }
                    },
                    axisLabel: {
                        color:'#16A9D0',
                    },
                    axisTick:{ //y轴刻度线
                        show:false
                    },
                    axisLine:{ //y轴
                        show:false
                    },
                    minInterval: 0.5,
                },
                series: [
                    {
                        type: 'line',
                        stack: 'Total',
                        smooth: true,
                        lineStyle: {
                            width: 0
                        },
                        showSymbol: false,
                        itemStyle : {
                            color:'#16A9D0',
                        },
                        label: {
                            show: true,
                            position: 'top',
                            color:'#fff',
                            fontSize:'14'
                        },
                        areaStyle: {
                            opacity:1,
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                            {
                                offset: 0,
                                color: '#16A9D0'
                            },
                            {
                                offset: 1,
                                color: '#0AD6DB'
                            }
                            ])
                        },
                        emphasis: {
                            focus: 'series'
                        },
                        data: []
                    },
                    {
                        type: 'scatter',
                        xAxisIndex: 0,
                        yAxisIndex: 0,
                        data: [],
                        itemStyle: {
                            color: "#16A9D0",
                        },
                        label: {
                            show:true,
                            position:"top",
                            color: "#16A9D0",
                            fontSize: 14,
                        },
                        animation: false,
                    },
                ],
                tooltip : {
                    trigger:'axis',
                    backgroundColor: "rgba(255,255,255,0)",
                    axisPointer:{
                            lineStyle:{
                                color:'rgba(0,0,0,0)'
                            }
                    },
                    formatter:function(param){
                        return '';
                    }
                }
            },
            line2_option: {
                title: {
                    text: '压力(MPa)',
                    textStyle: {
                        color: '#fff',
                        fontSize:14,
                        fontWeight: 'normar'
                    },
                    x: 'center'
                },
                grid: { left: '20', right: '20',top:'40',bottom: '10', containLabel: true},
                xAxis: {
                    show:false,
                    type: 'category',
                    data: [],
                    boundaryGap: false,
                },
                yAxis: {
                    type: 'value',
                    splitLine: {
                        show: true,
                        lineStyle: {
                            color: '#404750', 
                            width: 1, 
                        }
                    },
                    axisLabel: {
                        color:'#16A9D0',
                    },
                    axisTick:{ //y轴刻度线
                        show:false
                    },
                    axisLine:{ //y轴
                        show:false
                    },
                    minInterval: 0.5,
                },
                series: [
                    {
                        type: 'line',
                        stack: 'Total',
                        smooth: true,
                        lineStyle: {
                            width: 0
                        },
                        showSymbol: false,
                        itemStyle : {
                            color:'#16A9D0',
                        },
                        label: {
                            show: true,
                            position: 'top',
                            color:'#fff',
                            fontSize:'14'
                        },
                        areaStyle: {
                            opacity:1,
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                            {
                                offset: 0,
                                color: '#16A9D0'
                            },
                            {
                                offset: 1,
                                color: '#0AD6DB'
                            }
                            ])
                        },
                        emphasis: {
                            focus: 'series'
                        },
                        data: []
                    },
                    {
                        type: 'scatter',
                        xAxisIndex: 0,
                        yAxisIndex: 0,
                        data: [],
                        itemStyle: {
                            color: "#16A9D0",
                        },
                        label: {
                            show:true,
                            position:"top",
                            color: "#16A9D0",
                            fontSize: 14,
                        },
                        animation: false,
                    },
                ],
                tooltip : {
                    trigger:'axis',
                    backgroundColor: "rgba(255,255,255,0)",
                    axisPointer:{
                            lineStyle:{
                                color:'rgba(0,0,0,0)'
                            }
                    },
                    formatter:function(param){
                        return '';
                    }
                }
            },
            line3_option: {
                title: {
                    text: '密度(g/cm³)',
                    textStyle: {
                        color: '#fff',
                        fontSize:14,
                        fontWeight: 'normar'
                    },
                    x: 'center'
                },
                grid: { left: '20', right: '20',top:'40',bottom: '10', containLabel: true},
                xAxis: {
                    show:false,
                    type: 'category',
                    data: [],
                    boundaryGap: false,
                },
                yAxis: {
                    type: 'value',
                    splitLine: {
                        show: true,
                        lineStyle: {
                            color: '#404750', 
                            width: 1, 
                        }
                    },
                    axisLabel: {
                        color:'#16A9D0',
                    },
                    axisTick:{ //y轴刻度线
                        show:false
                    },
                    axisLine:{ //y轴
                        show:false
                    },
                    minInterval: 0.5,
                },
                series: [
                    {
                        type: 'line',
                        stack: 'Total',
                        smooth: true,
                        lineStyle: {
                            width: 0
                        },
                        showSymbol: false,
                        itemStyle : {
                            color:'#16A9D0',
                        },
                        label: {
                            show: true,
                            position: 'top',
                            color:'#fff',
                            fontSize:'14'
                        },
                        areaStyle: {
                            opacity:1,
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                            {
                                offset: 0,
                                color: '#16A9D0'
                            },
                            {
                                offset: 1,
                                color: '#0AD6DB'
                            }
                            ])
                        },
                        emphasis: {
                            focus: 'series'
                        },
                        data: []
                    },
                    {
                        type: 'scatter',
                        xAxisIndex: 0,
                        yAxisIndex: 0,
                        data: [],
                        itemStyle: {
                            color: "#16A9D0",
                        },
                        label: {
                            show:true,
                            position:"top",
                            color: "#16A9D0",
                            fontSize: 14,
                        },
                        animation: false,
                    },
                ],
                tooltip : {
                    trigger:'axis',
                    backgroundColor: "rgba(255,255,255,0)",
                    axisPointer:{
                            lineStyle:{
                                color:'rgba(0,0,0,0)'
                            }
                    },
                    formatter:function(param){
                        return '';
                    }
                }
            },
            line4_option: {
                title: {
                    text: '流量(L)',
                    textStyle: {
                        color: '#fff',
                        fontSize:14,
                        fontWeight: 'normar'
                    },
                    x: 'center'
                },
                grid: { left: '20', right: '20',top:'40',bottom: '10', containLabel: true},
                xAxis: {
                    show:false,
                    type: 'category',
                    data: [],
                    boundaryGap: false,
                },
                yAxis: {
                    type: 'value',
                    splitLine: {
                        show: true,
                        lineStyle: {
                            color: '#404750', 
                            width: 1, 
                        }
                    },
                    axisLabel: {
                        color:'#16A9D0',
                    },
                    axisTick:{ //y轴刻度线
                        show:false
                    },
                    axisLine:{ //y轴
                        show:false
                    },
                    minInterval: 0.5,
                },
                series: [
                    {
                        type: 'line',
                        data: [],
                        showSymbol: false,
                        lineStyle: {
                            width: 2
                        },
                        itemStyle : {
                            color:'#05D5FF',
                        },
                        label: {
                            show: true,
                            position: 'top',
                            color:'#fff',
                            fontSize:'14'
                        }
                    },
                    {
                        type: 'line',
                        data: [],
                        showSymbol: false,
                        lineStyle: {
                            width: 2
                        },
                        itemStyle : {
                            color:'#FFF549',
                        },
                        label: {
                            show: true,
                            position: 'bottom',
                            color:'#fff',
                            fontSize:'14'
                        }
                    },
                    {
                        type: 'scatter',
                        xAxisIndex: 0,
                        yAxisIndex: 0,
                        data: [],
                        itemStyle: {
                            color: "#05D5FF",
                        },
                        label: {
                            show:true,
                            position:"top",
                            color: "#05D5FF",
                            fontSize: 14,
                        },
                        animation: false,
                    },
                    {
                        type: 'scatter',
                        xAxisIndex: 0,
                        yAxisIndex: 0,
                        data: [],
                        itemStyle: {
                            color: "#FFF549",
                        },
                        label: {
                            show:true,
                            position:"bottom",
                            color: "#FFF549",
                            fontSize: 14,
                        },
                        animation: false,
                    },
                ],
                tooltip : {
                    trigger:'axis',
                    backgroundColor: "rgba(255,255,255,0)",
                    axisPointer:{
                            lineStyle:{
                                color:'rgba(0,0,0,0)'
                            }
                    },
                    formatter:function(param){
                        return '';
                    }
                }
            },
            line5_option: {
                title: {
                    text: '压力(MPa)',
                    textStyle: {
                        color: '#fff',
                        fontSize:14,
                        fontWeight: 'normar'
                    },
                    x: 'center'
                },
                grid: { left: 20, right: 20,top:40,bottom: 10, containLabel: true},
                xAxis: {
                    show:false,
                    type: 'category',
                    data: [],
                    boundaryGap: false,
                },
                yAxis: {
                    type: 'value',
                    splitLine: {
                        show: true,
                        lineStyle: {
                            color: '#404750', 
                            width: 1, 
                        }
                    },
                    axisLabel: {
                        color:'#16A9D0',
                    },
                    axisTick:{ //y轴刻度线
                        show:false
                    },
                    axisLine:{ //y轴
                        show:false
                    },                    
                    minInterval: 0.5,
                },
                series: [
                    {
                        type: 'line',
                        data: [],
                        showSymbol: false,
                        lineStyle: {
                            width: 2
                        },
                        itemStyle : {
                            color:'#05D5FF',
                        },
                        label: {
                            show: true,
                            position: 'top',
                            color:'#fff',
                            fontSize:'14'
                        }
                    },
                    {
                        type: 'line',
                        data: [],
                        showSymbol: false,
                        lineStyle: {
                            width: 2
                        },
                        itemStyle : {
                            color:'#FFF549',
                        },
                        label: {
                            show: true,
                            position: 'bottom',
                            color:'#fff',
                            fontSize:'14'
                        }
                    },
                    {
                        type: 'scatter',
                        xAxisIndex: 0,
                        yAxisIndex: 0,
                        data: [],
                        itemStyle: {
                            color: "#05D5FF",
                        },
                        label: {
                            show:true,
                            position:"top",
                            color: "#05D5FF",
                            fontSize: 14,
                        },
                        animation: false,
                    },
                    {
                        type: 'scatter',
                        xAxisIndex: 0,
                        yAxisIndex: 0,
                        data: [],
                        itemStyle: {
                            color: "#FFF549",
                        },
                        label: {
                            show:true,
                            position:"bottom",
                            color: "#FFF549",
                            fontSize: 14,
                        },
                        animation: false,
                    },
                ],
                tooltip : {
                    trigger:'axis',
                    backgroundColor: "rgba(255,255,255,0)",
                    axisPointer:{
                            lineStyle:{
                                color:'rgba(0,0,0,0)'
                            }
                    },
                    formatter:function(param){
                        return '';
                    }
                },
            },
            line6_option: {
                title: {
                    text: '密度(g/cm³)',
                    textStyle: {
                        color: '#fff',
                        fontSize:14,
                        fontWeight: 'normar'
                    },
                    x: 'center'
                },
                grid: { left: 20, right: 20,top:40,bottom: 10, containLabel: true},
                xAxis: {
                    show:false,
                    type: 'category',
                    data: [],
                    boundaryGap: false,
                },
                yAxis: {
                    type: 'value',
                    splitLine:{show: false},
                    splitLine: {
                        show: true,
                        lineStyle: {
                            color: '#404750', 
                            width: 1, 
                        }
                    },
                    axisLabel: {
                        color:'#16A9D0',
                    },
                    axisTick:{ //y轴刻度线
                        show:false
                    },
                    axisLine:{ //y轴
                        show:false
                    },
                    minInterval: 0.5,
                },
                series: [
                    {
                        type: 'line',
                        data: [],
                        showSymbol: false,
                        lineStyle: {
                            width: 2
                        },
                        itemStyle : {
                            color:'#05D5FF',
                        },
                        label: {
                            show: true,
                            position: 'top',
                            color:'#fff',
                            fontSize:'14'
                        }
                    },
                    {
                        type: 'line',
                        data: [],
                        showSymbol: false,
                        lineStyle: {
                            width: 2
                        },
                        itemStyle : {
                            color:'#FFF549',
                        },
                        label: {
                            show: true,
                            position: 'bottom',
                            color:'#fff',
                            fontSize:'14'
                        }
                    },
                    {
                        type: 'scatter',
                        xAxisIndex: 0,
                        yAxisIndex: 0,
                        data: [],
                        itemStyle: {
                            color: "#05D5FF",
                        },
                        label: {
                            show:true,
                            position:"top",
                            color: "#05D5FF",
                            fontSize: 14,
                        },
                        animation: false,
                    },
                    {
                        type: 'scatter',
                        xAxisIndex: 0,
                        yAxisIndex: 0,
                        data: [],
                        itemStyle: {
                            color: "#FFF549",
                        },
                        label: {
                            show:true,
                            position:"bottom",
                            color: "#FFF549",
                            fontSize: 14,
                        },
                        animation: false,
                    },
                ],
                tooltip : {
                    trigger:'axis',
                    backgroundColor: "rgba(255,255,255,0)",
                    axisPointer:{
                            lineStyle:{
                                color:'rgba(0,0,0,0)'
                            }
                    },
                    formatter:function(param){
                        return '';
                    }
                },
            },
            imgServer: config.imgServer,
        }
    },
    mounted() {
        this.getIndexData()
        this.getRealData()
        this.continueSession()
    },
    beforeCreate(){
        console.log("销毁...")
    },
    methods: {
        getIndexData(){
            indexData().then(res=>{
                if(res.code ==1){
                    this.user_id = res.data.user_id
                    this.pid = res.data.pid
                    this.nickName = res.data.nickName
                    this.project = res.data.project
                    this.dyList = res.data.dyList
                    this.dwList = res.data.dwList
                    this.fbList = res.data.fbList
                    this.contactList = res.data.contactList
                    this.uncontactList = res.data.uncontactList
                    if(this.uncontactList && this.uncontactList.length>0 && this.contactList && this.contactList.length>0){
                        for(let i=0; i<this.uncontactList.length; i++){
                            let unc = this.uncontactList[i]
                            for(let j=0; j<this.contactList.length; j++){
                                let c = this.contactList[j]
                                if(c.code == unc.check_code){
                                    this.uncontactList[i].check_id = j;
                                    break;
                                }
                            }
                        }
                    }
                    this.pie_option.series[0].data[0].value = res.data.volume1
                    this.pie_option.series[0].data[1].value = res.data.volume2
                    this.pie_option.series[0].data[2].value = res.data.volume3
                    var pie_echart = echarts.init(document.getElementById("pie_echart"));
                    pie_echart.setOption(this.pie_option);

                    this.line1_echart = echarts.init(document.getElementById("line1"));
                    this.line2_echart = echarts.init(document.getElementById("line2"));
                    this.line3_echart = echarts.init(document.getElementById("line3"));
                    this.line4_echart = echarts.init(document.getElementById("line4"));
                    this.line5_echart = echarts.init(document.getElementById("line5"));
                    this.line6_echart = echarts.init(document.getElementById("line6"));
                    this.$globalData.timmer2 && clearTimeout(this.$globalData.timmer2)
                    this.$globalData.timmer2 = setTimeout(() => {
                        this.getIndexData()
                    }, 5*60*1000);
                }else{
                    this.$msg(res.msg)
                }
            })
        },
        getRealData(){
            this.contact_timmer = this.contact_timmer+1
            this.channel_timmer = this.channel_timmer+1
            this.uncontact_timmer = this.uncontact_timmer+1
            if(this.contact_timmer > 120){
                this.contact_timmer = 1;
                this.channel_timmer = 1
                this.channel_index = 1
                this.contact_index = this.contact_index+1
                if(this.contact_index >= this.contactList.length){
                    this.contact_index = 0
                }
            }
            if(this.channel_timmer > 60){
                this.channel_timmer = 1;
                if(this.channel_index ==1){
                    this.channel_index = 2
                }else{
                    this.channel_index = 1
                }
            }
            if(this.uncontact_timmer > 120){
                this.uncontact_timmer = 1;
                this.uncontact_index = this.uncontact_index+1
                if(this.uncontact_index >= this.uncontactList.length){
                    this.uncontact_index = 0
                }
            }
            realData().then(res=>{
                if(res.code ==1){
                    let contactDataList = res.data.contactDataList
                    let uncontactDataList = res.data.uncontactDataList
                    if(contactDataList && this.contactList && contactDataList.length>0 && this.contactList.length>0 && this.contactList.length == contactDataList.length){
                        for(let i=0; i<contactDataList.length; i++){
                            let vo = contactDataList[i]
                            let volist = vo.data
                            let data0 = new Array()
                            let data1 = new Array()
                            let data2 = new Array()
                            let data3 = new Array()
                            let data4 = new Array()
                            let data5 = new Array()
                            let data6 = new Array()
                            if(volist.length>0){
                                for(let j=0; j<volist.length; j++){
                                    let t = volist[j]
                                    data0.push(t.time)
                                    data1.push(t.flow1)
                                    data2.push(t.pressure1)
                                    data3.push(t.density1)
                                    data4.push(t.flow2)
                                    data5.push(t.pressure2)
                                    data6.push(t.density2)
                                }
                            }
                            this.contactList[i]['data0'] = data0
                            this.contactList[i]['data1'] = data1
                            this.contactList[i]['data2'] = data2
                            this.contactList[i]['data3'] = data3
                            this.contactList[i]['data4'] = data4
                            this.contactList[i]['data5'] = data5
                            this.contactList[i]['data6'] = data6
                            this.contactList[i].state = vo.state
                        }
                        this.setRealData()
                    }

                    if(uncontactDataList && this.uncontactList && uncontactDataList.length>0 && this.uncontactList.length>0 && this.uncontactList.length == uncontactDataList.length){
                        for(let i=0; i<uncontactDataList.length; i++){
                            let vo = uncontactDataList[i]
                            let volist = vo.data
                            let data0 = new Array()
                            let data1 = new Array()
                            let data2 = new Array()
                            let data3 = new Array()
                            if(volist.length>0){
                                for(let j=0; j<volist.length; j++){
                                    let t = volist[j]
                                    data0.push(t.time)
                                    data1.push(t.flow1)
                                    data2.push(t.pressure1)
                                    data3.push(t.density1)
                                }
                            }
                            this.uncontactList[i]['data0'] = data0
                            this.uncontactList[i]['data1'] = data1
                            this.uncontactList[i]['data2'] = data2
                            this.uncontactList[i]['data3'] = data3
                            this.uncontactList[i].state = vo.state
                        }
                        this.setRealData1()
                    }

                    setTimeout(() => {
                        this.getRealData()
                    }, 1000);
                }else{
                    this.$msg(res.msg)
                }
            })
        },
        setRealData(){
            this.line1_option.xAxis.data = this.contactList[this.contact_index]['data0']
            this.line2_option.xAxis.data = this.contactList[this.contact_index]['data0']
            this.line3_option.xAxis.data = this.contactList[this.contact_index]['data0']
            if(this.channel_index ==1){
                this.line1_option.series[0].data = this.contactList[this.contact_index]['data1']
                this.line2_option.series[0].data = this.contactList[this.contact_index]['data2']
                this.line3_option.series[0].data = this.contactList[this.contact_index]['data3']
                this.line1_option.series[1].data = [[this.contactList[this.contact_index]['data1'].length-1, this.contactList[this.contact_index]['data1'][this.contactList[this.contact_index]['data1'].length-1]]]
                this.line2_option.series[1].data = [[this.contactList[this.contact_index]['data2'].length-1, this.contactList[this.contact_index]['data2'][this.contactList[this.contact_index]['data2'].length-1]]]
                this.line3_option.series[1].data = [[this.contactList[this.contact_index]['data3'].length-1, this.contactList[this.contact_index]['data3'][this.contactList[this.contact_index]['data3'].length-1]]]
            }else{
                this.line1_option.series[0].data = this.contactList[this.contact_index]['data4']
                this.line2_option.series[0].data = this.contactList[this.contact_index]['data5']
                this.line3_option.series[0].data = this.contactList[this.contact_index]['data6']
                this.line1_option.series[1].data = [[this.contactList[this.contact_index]['data4'].length-1, this.contactList[this.contact_index]['data4'][this.contactList[this.contact_index]['data4'].length-1]]]
                this.line2_option.series[1].data = [[this.contactList[this.contact_index]['data5'].length-1, this.contactList[this.contact_index]['data5'][this.contactList[this.contact_index]['data5'].length-1]]]
                this.line3_option.series[1].data = [[this.contactList[this.contact_index]['data6'].length-1, this.contactList[this.contact_index]['data6'][this.contactList[this.contact_index]['data6'].length-1]]]
            }
            this.line1_echart.setOption(applyLineChartTheme(this.line1_option));
            this.line2_echart.setOption(applyLineChartTheme(this.line2_option));
            this.line3_echart.setOption(applyLineChartTheme(this.line3_option));
        },
        setRealData1(){
            this.line4_option.xAxis.data = this.uncontactList[this.uncontact_index]['data0']
            this.line5_option.xAxis.data = this.uncontactList[this.uncontact_index]['data0']
            this.line6_option.xAxis.data = this.uncontactList[this.uncontact_index]['data0']
            this.line4_option.series[1].data = this.uncontactList[this.uncontact_index]['data1']
            this.line5_option.series[1].data = this.uncontactList[this.uncontact_index]['data2']
            this.line6_option.series[1].data = this.uncontactList[this.uncontact_index]['data3']
            this.line4_option.series[3].data = [[this.uncontactList[this.uncontact_index]['data1'].length-1, this.uncontactList[this.uncontact_index]['data1'][this.uncontactList[this.uncontact_index]['data1'].length-1]]]
            this.line5_option.series[3].data = [[this.uncontactList[this.uncontact_index]['data2'].length-1, this.uncontactList[this.uncontact_index]['data2'][this.uncontactList[this.uncontact_index]['data2'].length-1]]]
            this.line6_option.series[3].data = [[this.uncontactList[this.uncontact_index]['data3'].length-1, this.uncontactList[this.uncontact_index]['data3'][this.uncontactList[this.uncontact_index]['data3'].length-1]]]
            if(this.uncontactList[this.uncontact_index].channel_no=="1"){
                this.line4_option.series[0].data = this.contactList[this.uncontactList[this.uncontact_index].check_id]['data1']
                this.line5_option.series[0].data = this.contactList[this.uncontactList[this.uncontact_index].check_id]['data2']
                this.line6_option.series[0].data = this.contactList[this.uncontactList[this.uncontact_index].check_id]['data3']
                this.line4_option.series[2].data = [[this.contactList[this.uncontactList[this.uncontact_index].check_id]['data1'].length-1, this.contactList[this.uncontactList[this.uncontact_index].check_id]['data1'][this.contactList[this.uncontactList[this.uncontact_index].check_id]['data1'].length-1]]]
                this.line5_option.series[2].data = [[this.contactList[this.uncontactList[this.uncontact_index].check_id]['data2'].length-1, this.contactList[this.uncontactList[this.uncontact_index].check_id]['data2'][this.contactList[this.uncontactList[this.uncontact_index].check_id]['data2'].length-1]]]
                this.line6_option.series[2].data = [[this.contactList[this.uncontactList[this.uncontact_index].check_id]['data3'].length-1, this.contactList[this.uncontactList[this.uncontact_index].check_id]['data3'][this.contactList[this.uncontactList[this.uncontact_index].check_id]['data3'].length-1]]]
            }else{
                this.line4_option.series[0].data = this.contactList[this.uncontactList[this.uncontact_index].check_id]['data4']
                this.line5_option.series[0].data = this.contactList[this.uncontactList[this.uncontact_index].check_id]['data5']
                this.line6_option.series[0].data = this.contactList[this.uncontactList[this.uncontact_index].check_id]['data6']
                this.line4_option.series[2].data = [[this.contactList[this.uncontactList[this.uncontact_index].check_id]['data4'].length-1, this.contactList[this.uncontactList[this.uncontact_index].check_id]['data4'][this.contactList[this.uncontactList[this.uncontact_index].check_id]['data4'].length-1]]]
                this.line5_option.series[2].data = [[this.contactList[this.uncontactList[this.uncontact_index].check_id]['data5'].length-1, this.contactList[this.uncontactList[this.uncontact_index].check_id]['data5'][this.contactList[this.uncontactList[this.uncontact_index].check_id]['data5'].length-1]]]
                this.line6_option.series[2].data = [[this.contactList[this.uncontactList[this.uncontact_index].check_id]['data6'].length-1, this.contactList[this.uncontactList[this.uncontact_index].check_id]['data6'][this.contactList[this.uncontactList[this.uncontact_index].check_id]['data6'].length-1]]]
            }
            this.line4_echart.setOption(applyLineChartTheme(this.line4_option))
            this.line5_echart.setOption(applyLineChartTheme(this.line5_option))
            this.line6_echart.setOption(applyLineChartTheme(this.line6_option))
        },
        changeContact(idx){
            this.contact_index = idx
            this.contact_timmer = 1
            this.channel_timmer = 1
            this.channel_index = 1
            this.setRealData()
        },
        changeChannel(idx){
            this.channel_timmer = 1
            this.channel_index = idx
            this.setRealData()
        },
        changeUnContact(idx){
            this.uncontact_index = idx
            this.uncontact_timmer = 1
        },
        continueSession(){
            continueSession().then(res=>{})
            setTimeout(() => {
                this.continueSession()
            }, 60*1000);
        },
    }
}
</script>